module.exports = __webpack_public_path__ + "static/media/7.3e4dfcb1.png";